module.exports = __webpack_public_path__ + "static/media/Background_Payment_Page.64a78558.svg";